export default {
	code: [
		{
			code: '01',
			name: 'RUC',
			typePerson: 7,
		},
		{
			code: '02',
			name: 'CEDULA',
			typePerson: 8,
		},
		{
			code: '03',
			name: 'PASAPORTE',
			typePerson: 9,
		},
		{
			code: '01',
			name: 'RUC',
			typePerson: 18,
		},
	],
};



// WEBPACK FOOTER //
// ./src/shared/codePurchases.js